{
  "everyone": "Everyone",
  "add_recipient": "Add a new recipient",
  "delete_recipient": "Delete recipient",
  "delete_toast": {
    "success": "Deleted {{name}}",
    "error": "Error deleting {{name}}"
  },
  "confirm_delete": {
    "title": "Delete {{name}}?",
    "confirm": "Yes, delete"
  }
}
